import * as React from 'react'

interface IEntityBottomPanelBoxBtnProps {
  children: any
  onClick?: () => void
  className?: string
}

const EntityBottomPanelBoxBtn = (props: IEntityBottomPanelBoxBtnProps) => {
  return (
    <div className={`flex items-center cursor--pointer ${props.className}`} onClick={props.onClick}>
      {props.children}
    </div>
  )
}

export default EntityBottomPanelBoxBtn



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityBottomPanelBoxBtn.tsx